<template>
	<section ref="componentRef"
			 class="flex-module container-fluid flexible-services">
		<div class="row">
			<div v-if="item.title"
				 class="col-xs-12">
				<h2 class="section-title">
					{{ item.title }}
				</h2>
			</div>
		</div>
		<div class="row">
			<div v-for="column in item.columns"
				 :key="column.text"
				 class="col-xs-12 col-md-4 service-column">
				<div v-if="column.button_url"
					 class="services-link">
					<baseButton :to="column.button_url"
								classes="secondary">
						<template v-if="column.button_title">
							{{ column.button_title }}
						</template>
						<template v-else>
							{{ column.button_url }}
						</template>
					</baseButton>
				</div>

				<baseRichText class="services-text"
							  :data="column.body" />
			</div>
		</div>
		<div v-if="item.services && item.expand_button_title"
			 class="row">
			<div class="col-xs-12 show-services-wrapper">
				<button class="show-services-button"
						@click="toggleAccordion">
					<!-- {{ item.expand_button_title }} -->
					{{ revealed ? 'Hide the long list of how we can help you' : item.expand_button_title }}
				</button>
				<i>
					<svg class="arrow"
						 :class="[{ 'active': revealed }]"
						 viewBox="0 0 27 34"
						 fill="none"
						 xmlns="http://www.w3.org/2000/svg">
						<line class="line"
							  x1="13.5"
							  y1="2"
							  x2="13.5"
							  y2="28"
							  stroke="currentColor" />
						<path class="caret"
							  d="M24.9,19.5L13.5,31L2,19.5"
							  stroke="currentColor" />
					</svg>
				</i>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12"
				 :class="['showservices', { 'active': revealed }]">

				<div class="row">

					<div v-for="(column, i) in serviceColumns"
						 :key="`column-${i}`"
						 class="col-xs-12 col-md-4">

						<div v-for="({ service }, i2) in column"
							 :key="`service-${i2}`"
							 class="service-name">
							<p v-if="service.title">
								{{ service.title }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
})

const { gsap, ScrollTrigger } = useGsap()

const componentRef = ref(null)
const revealed = ref(false)
let $q

const item = computed(() => {
	return props.data.item
})

const serviceColumns = computed(() => {
	if (!item.value.services) return []

	return groupsByN(item.value.services, 3)
})

let showservices, line, caret
function toggleAccordion() {
	revealed.value = !revealed.value

	if (revealed.value) {
		gsap
			.timeline({
				overwrite: true,
				onComplete: () => {
					ScrollTrigger.refresh()
				}
			})
			.to(showservices, {
				height: 'auto',
				duration: 0.6,
			})
			.to(caret, {
				scaleY: -1,
				y: -17,
				duration: 0.4,
			}, 0)
			.to(line, {
				y: 5,
			}, 0)
	} else if (caret.length) {
		gsap
			.timeline({
				overwrite: true,
				onComplete: () => {
					ScrollTrigger.refresh()
				}
			})
			.to(showservices, {
				height: 0,
				duration: 0.4,
			})
			.to(caret, {
				scaleY: 1,
				y: 0,
				duration: 0.25,
			}, '<')
			.to(line, {
				y: 0,
			}, '<')
	}
}

function initAnims() {
	$q = gsap.utils.selector(componentRef.value)
	showservices = $q('.showservices')
	line = $q('.line')
	caret = $q('.caret')

	if (caret.length) {
		gsap.set($q('.caret'), {
			transformOrigin: 'center',
		})
	}
}

onMounted(() => {
	useAnims(initAnims)
})
</script>

<style lang="scss" scoped>
.service-column {
	@include for-devices-below(md) {
		&:not(:first-of-type) {
			padding-top: 10vmin;
		}
	}

	.services-link {
		margin-block-end: 50px;
	}

	.services-text {
		// margin-top: rem-calc(58);
		@include textBody;
	}
}

.show-services-wrapper {
	position: relative;
	margin-top: rem-calc(40);
	padding-bottom: rem-calc(10);
	padding-right: rem-calc(40);

	.show-services-button {
		position: relative;
		color: var(--foreground-color, $black);
		float: right;
		box-shadow: none;
		cursor: pointer;
		@include textBody;
		@include standard-link;
		font-weight: $semiBold;
	}

	i {
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(calc(-50%));
		display: inline-block;

		overflow: hidden;

		.arrow {
			position: relative;
			width: 25px;
			height: 30px;
			// transform: translateY(5px);

			.line,
			.caret {
				vector-effect: non-scaling-stroke;
				stroke-width: 2px;

				@include for-devices-above(lg) {
					stroke-width: 4px;
				}
			}

			.line {
				transform: unset;
				transform: translateY(0);
			}

			.caret {
				position: absolute;

			}
		}
	}
}



.showservices {
	overflow: hidden;
	height: 0;

	.service-name {
		border-bottom: 2px solid $black;
		padding: rem-calc(12) 0;

		@include for-devices-above(lg) {
			border-width: 4px;
		}

		@include for-devices-above(sm) {
			padding: rem-calc(14) 0;
		}

		@include for-devices-above(md) {
			padding: rem-calc(36) 0;
		}

		p {
			@include textBody;
		}
	}
}
</style>